import { BeneficiaryTypeEnum } from './model/enums/BeneficiaryTypeEnum';

export class Constants {
  private static NlDateFormat = 'd MMMM yyyy';
  private static EnDateFormat = 'd MMMM yyyy';
  private static NlDateTimeFormat = 'dd-MM-yyyy HH:mm:ss';
  private static EnDateTimeFormat = 'dd/MM/yyyy HH:mm:ss';

  // tslint:disable-next-line: max-line-length
  static emailValidationPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static urlRegexpPattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i');
  static policyTermsPattern = /(.*)(\_\d{4})(\_.*)/;
  static viewClaimUrlPattern = /(.*)viewClaim(.*)/;
  static phonePattern = /^6\d{8}$/;
  static phoneInputMask = '0 00 00 00 00';

  static ibanInputMask = 'AA00 AAAA 0000 0000 00';

  static medicalOfficeEmail = 'katrien.vandermaesen@sedgwick.com';
  static medicalOfficeName = 'Sedgwick';

  static DateFormat = Constants.NlDateFormat;
  static DateTimeFormat = Constants.NlDateTimeFormat;

  static Locale = 'en-GB';

  static funeralTerms: string[] = ['UVV', 'CUV'];

  // Role names
  static INTERMEDIARY = 'intermediary';
  static END_CUSTOMER = 'end-customer';

  static DEFAULT_BENEFICIARY_ORDER = [
    BeneficiaryTypeEnum.POLICY_HOLDER,
    BeneficiaryTypeEnum.WIDOW,
    BeneficiaryTypeEnum.CHILDREN,
    BeneficiaryTypeEnum.HEIRS,
  ];

  static THOUSAND_SEPARATOR = '.';

  static uuidv4(): string {
    return 'fxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxqx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line: no-bitwise
      const r = (Math.random() * 16) | 0;
      // tslint:disable-next-line: no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  static _Initialize(): void {
    const nlLanguageCode = 'nl';
    Constants.DateFormat = navigator.language.startsWith(nlLanguageCode)
      ? Constants.NlDateFormat
      : Constants.EnDateFormat;

    Constants.DateTimeFormat = navigator.language.startsWith(nlLanguageCode)
      ? Constants.NlDateTimeFormat
      : Constants.EnDateTimeFormat;

    Constants.Locale = navigator.language.startsWith(nlLanguageCode)
      ? 'nl-NL'
      : 'en-GB';
  }
}

Constants._Initialize();
